import http from "./HttpService";

var endpoint = `/lookup/`;
const eventEndPoint = `/lookup/event/`;
const partnerEndPoint = `/lookup/partnership/`;
const citizenScience = `/lookup/citizen/science/`;

const getTitles = async () => {
  const response = await http.get(`${endpoint}titles`);
  return response;
};

const getRaces = async () => {
  const response = await http.get(`${endpoint}races?isEventRequest=true`);
  return response;
};

const getGenders = async () => {
  const response = await http.get(`${endpoint}genders`);
  return response;
};

const getProvinces = async () => {
  const response = await http.get(`${endpoint}south-africa/provinces`);
  return response;
};

const getProgrammes = async () => {
  const response = await http.get(`${endpoint}system-modules`);
  return response;
};

const getLanguages = async () => {
  const response = await http.get(`${endpoint}south-africa/languages`);
  return response;
};

const getEventTypes = async () => {
  const response = await http.get(`${endpoint}event/venue/types`);
  return response;
};

const getEventGroups = async () => {
  const response = await http.get(`${endpoint}event/groups`);
  return response;
};

const getDisability = async () => {
  const response = await http.get(`${eventEndPoint}participant/disabilities`);
  return response;
};
const getFaqModule = async () => {
  const response = await http.get(`${endpoint}system-modules`);
  return response;
};

const getLanguges = async () => {
  const response = await http.get(`${endpoint}south-africa/languages`);
  return response;
};

const getProvincesDistrictTowns = async () => {
  const response = await http.get(`${endpoint}south-africa/province-district-towns`);
  return response;
};
const getParticipantTypes = async () => {
  const response = await http.get(`${eventEndPoint}participant/types`);
  return response;
}


const getLocalityTypes = async () => {
  const response = await http.get(`${partnerEndPoint}locality`);
  return response;
};

const getAgeGroup = async () => {
  const response = await http.get(`${eventEndPoint}participant/age-groups`);
  return response;
}

const getParticipantsMotivations = async () => {
  const response = await http.get(`${citizenScience}participant-motivations`);
  return response;
}
// eslint-disable-next-line import/no-anonymous-default-export
export default {

  getTitles,
  getRaces,
  getGenders,
  getDisability,
  getProvinces,
  getEventTypes,
  getEventGroups,
  getAgeGroup,
  getLanguges,
  getFaqModule, 
  getProvincesDistrictTowns,
  getParticipantTypes,
  getLocalityTypes,
  getParticipantsMotivations
};
